/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { fromJS, List } from 'immutable';
import * as constants from 'data/constants/notification-settings';
import LoadingProgress from 'data/utils/reducers/loading';

export const siteMutesLoadingProgress = (siteId: string | number) => new LoadingProgress(`siteMutes${siteId}`);
export const mutesLoadingProgress = new LoadingProgress('mutes');
export const preferencesLoadingProgress = new LoadingProgress('preferences');

const withoutMute = (mutes: any, muteId: number) => mutes.filter((mute: any) => mute.get('id') !== muteId);

const deleteMute = (state: any, muteId: number) =>
  state.withMutations((newState: any) => {
    newState.update('siteMutes', (bySite: any) => bySite.map((mutes: any) => withoutMute(mutes, muteId)));
    if (newState.get('mutes')) {
      newState.update('mutes', (mutes: any) => withoutMute(mutes, muteId));
    }
  });

const updatePreference = (state: any, payload: any) => {
  const updated = fromJS(payload);
  return state.update('preferences', List(), (preferences: any) => {
    const index = preferences.findIndex((row: any) => row.get('channel_type') === updated.get('channel_type'));
    return index === -1 ? preferences.push(updated) : preferences.set(index, updated);
  });
};

const initialState = fromJS({ siteMutes: {} });

export default (state = initialState, action: any) => {
  switch (action.type) {
    case constants.SITE_MUTES_LOAD_START:
      return siteMutesLoadingProgress(action.payload.siteId).setLoading(state);
    case constants.SITE_MUTES_LOAD_FAILED:
      return siteMutesLoadingProgress(action.payload.siteId).setLoadFailed(state);
    case constants.SITE_MUTES_LOAD_SUCCESS:
      return state.withMutations((newState: any) => {
        newState.setIn(['siteMutes', String(action.payload.siteId)], fromJS(action.payload.mutes));
        siteMutesLoadingProgress(action.payload.siteId).setLoaded(newState);
      });

    case constants.MUTES_LOAD_START:
      return mutesLoadingProgress.setLoading(state);
    case constants.MUTES_LOAD_FAILED:
      return mutesLoadingProgress.setLoadFailed(state);
    case constants.MUTES_LOAD_SUCCESS:
      return state.withMutations((newState: any) => {
        newState.set('mutes', fromJS(action.payload));
        mutesLoadingProgress.setLoaded(newState);
      });

    case constants.MUTE_DELETED:
      return deleteMute(state, action.payload.muteId);

    case constants.PREFERENCES_LOAD_START:
      return preferencesLoadingProgress.setLoading(state);
    case constants.PREFERENCES_LOAD_FAILED:
      return preferencesLoadingProgress.setLoadFailed(state);
    case constants.PREFERENCES_LOAD_SUCCESS:
      return state.withMutations((newState: any) => {
        newState.set('preferences', fromJS(action.payload));
        preferencesLoadingProgress.setLoaded(newState);
      });
    case constants.PREFERENCE_UPDATED:
      return updatePreference(state, action.payload);

    default:
      return state;
  }
};
